export const preventReload = (form) => {
    const unloadCallback = (event) => {
        if(Object.values(form.getFieldValue()).length > 0){
          event.preventDefault();
          event.returnValue = "";
          return "";
        }
      };
    
      window.addEventListener("beforeunload", unloadCallback);
      return () => window.removeEventListener("beforeunload", unloadCallback);
}